// var _ = require("?underscore");

var pieGraph = require("./PieGraph");
var lineGraph = require("./LineMultilineGraph");
var columnGraph = require("./ColumnStackedGraph");
var areaGraph = require("./AreaStackedGraph");

var typeProcessorMap = {
  "pie": pieGraph,
  "line": lineGraph,
  "column": columnGraph,
  "area": areaGraph
};

var extractStructure = function(type, meta, data) {
  if ( !_.has(typeProcessorMap, type) ) {
    console.log("Missing graph type1!");
    return {};
  }

  return typeProcessorMap[type].extractStructure(type, meta, data);
}

var extractData = function(type, meta, data) {
  if ( !_.has(typeProcessorMap, type) ) {
    console.log("Missing graph type2!");
    return {};
  }

  return typeProcessorMap[type].extractData(type, meta, data);
}

var render = function(htmlElement, type, graphStructure, graphData) {
  if ( !_.has(typeProcessorMap, type) ) {
    console.log("Missing graph type3!");
    return {};
  }

  return typeProcessorMap[type].render(htmlElement, type, graphStructure, graphData);
};

module.exports = {
  extractStructure: extractStructure,
  extractData: extractData,
  render: render,
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataGraph/DataGraph.js
// module id = 7
// module chunks = 0